<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            New Field
          </h4>
          <h6 class="card-subtitle">
            Please keep your profile information always current in order to help you when you contact us.
          </h6>
        </div>
        <form class="form-horizontal" @submit.prevent="handleSubmit">
          <div class="card-body card-blue">
            <div class="form-group row">
              <label for="name" class="col-sm-3 text-right control-label col-form-label">Name</label>
              <div class="col-sm-5">
                <input id="name" v-model="field.name" v-validate="'required'" type="text" class="form-control" name="name" placeholder="Name" data-vv-as="Name" :class="{'is-invalid': submitted && errors.has('name')}">
                <div v-if="submitted && errors.has('name')" class="invalid-feedback">
                  {{ errors.first('name') }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="location" class="col-sm-3 text-right control-label col-form-label">Location</label>
              <div class="col-sm-5">
                <input id="location" v-model="field.location" v-validate="'required'" type="text" class="form-control" name="location" placeholder="Location" data-vv-as="Location" :class="{'is-invalid': submitted && errors.has('location')}">
                <div v-if="submitted && errors.has('location')" class="invalid-feedback">
                  {{ errors.first('location') }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="area" class="col-sm-3 text-right control-label col-form-label">Area</label>
              <div class="col-sm-5">
                <div class="input-group">
                  <input id="area" v-model="field.area" v-validate="'required'" type="text" class="form-control" name="area" placeholder="Area" data-vv-as="Area" :class="{'is-invalid': submitted && (errors.has('area') || errors.has('units'))}">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      {{ field.units }}
                    </button>
                    <div class="dropdown-menu" x-placement="bottom-start">
                      <a class="dropdown-item" @click="setAreaUnits('ha')">ha</a>
                      <a class="dropdown-item" @click="setAreaUnits('ac')">ac</a>
                      <a class="dropdown-item" @click="setAreaUnits('m2')">m<sup>2</sup></a>
                      <a class="dropdown-item" @click="setAreaUnits('yd2')">yd<sup>2</sup></a>
                    </div>
                  </div>
                  <div v-if="submitted && errors.has('area')" class="invalid-feedback">
                    {{ errors.first('area') }}
                  </div>
                  <div v-if="submitted && errors.has('units')" class="invalid-feedback">
                    {{ errors.first('units') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="cadastral" class="col-sm-3 text-right control-label col-form-label">Cadastral Plot</label>
              <div class="col-sm-5">
                <input id="cadastral" v-model="field.cadastral" v-validate="'required'" type="text" class="form-control" name="cadastral" placeholder="Cadastral Plot" data-vv-as="Cadastral Plot" :class="{'is-invalid': submitted && errors.has('cadastral')}">
                <div v-if="submitted && errors.has('cadastral')" class="invalid-feedback">
                  {{ errors.first('cadastral') }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="soil" class="col-sm-3 text-right control-label col-form-label">Soil</label>
              <div class="col-sm-5">
                <multiselect id="soil" v-model="field.soil" v-validate="'required'" name="soil" :options="soilTypes" class="form-control" label="text" track-by="text" placeholder="Select a soil type" data-vv-as="Soil Type" :class="{'is-invalid': submitted && errors.has('soil')}" />
                <div v-if="submitted && errors.has('soil')" class="invalid-feedback">
                  {{ errors.first('soil') }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="ownership" class="col-sm-3 text-right control-label col-form-label">Ownership</label>
              <div class="col-sm-5">
                <multiselect id="ownership" v-model="field.ownership" v-validate="'required'" name="ownership" :options="ownershipTypes" class="form-control" label="text" track-by="text" placeholder="Select a ownership type" data-vv-as="Ownership Type" :class="{'is-invalid': submitted && errors.has('ownership')}" />
                <div v-if="submitted && errors.has('ownership')" class="invalid-feedback">
                  {{ errors.first('ownership') }}
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="form-group m-b-0 text-right">
              <div class="button-group">
                <button type="submit" class="btn waves-effect waves-light btn-success">
                  Save
                </button>
                <button type="button" class="btn waves-effect waves-light btn-secondary" @click="reset()">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  name: 'NewField',
  components: { Multiselect },
  data () {
    return {
      submitted: false,
      field: {
        name: '',
        location: '',
        area: '',
        units: 'Select Units',
        cadastral: '',
        soil: '',
        ownership: '',
        geo: []
      },
      soilTypes: [
        { value: 'CLAY', text: 'Clay' },
        { value: 'CLAY_LOAM', text: 'Clay Loam' },
        { value: 'SAND', text: 'Sand' },
        { value: 'LOAM', text: 'Loam' },
        { value: 'LOAMY_SAND', text: 'Loamy Sand' },
        { value: 'SANDY_CLAY', text: 'Sandy Clay' },
        { value: 'SANDY_CLAY_LOAM', text: 'Sandy Clay Loam' },
        { value: 'SILT', text: 'Silt' },
        { value: 'SILT_LOAM', text: 'Silt Loam' },
        { value: 'SILT_CLAY', text: 'Silty Clay' },
        { value: 'SILT_CLAY_LOAM', text: 'Silty Clay Loam' }
      ],
      ownershipTypes: [
        { value: 'PRIVATELY_OWNED', text: 'Privately Owned' },
        { value: 'LEASE', text: 'Lease' },
        { value: 'GIVEN_FOR_USE', text: 'Given for Use' },
        { value: 'PROPERTY_MANAGER', text: 'Property Manager' },
        { value: 'OWNED_BY_RELATIVES', text: 'Owned by Relatives' },
        { value: 'MIXED', text: 'Mixed' },
        { value: 'OTHER', text: 'Other' }
      ]
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  methods: {
    setAreaUnits (units) {
      this.field.units = units
    },
    handleSubmit () {
      this.submitted = true
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.save()
          }
        })
    },
    async save () {
      await this.$api.put('/fields', this.field)
      this.$toastr('success', 'New field added successfully.', 'Field Saved')
      this.$router.push({ name: 'fields' })
    },
    reset () {
      this.submitted = false
      this.field = {
        name: '',
        location: '',
        area: '',
        units: 'Select Units',
        cadastral: '',
        soil: '',
        ownership: '',
        geo: []
      }
    }
  }
}
</script>

<style scoped>
</style>
